/* eslint-disable consistent-return */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useIsMapLoaded } from '@services/hooks.service';
import { addLayers, removeLayers } from './map-marker-layer.utils';

function MapMarkerLayer({
  isSingle = false,
  setSelectedMarker,
  selectedMarker,
  markerData, 
}) {
  const map = useSelector(state => state.maplibremap.map);

  const isMapLoaded = useIsMapLoaded(map);

  useEffect(() => {
    if (!map || !isMapLoaded) return;

    if (map.getLayer('malawi-regions-fill')) map.removeLayer('malawi-regions-fill');

    addLayers(map);

    return () => removeLayers(map);
  }, [map, isMapLoaded]);

  useEffect(() => {
    if (!map) return;

    if (!isMapLoaded) return;

    map.getSource('points').setData({
      type: 'FeatureCollection',
      features: markerData.map(marker => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [marker.lng, marker.lat],
        },
        properties: {
          id: marker.id,
          category: marker.category,
        },
      })),
    });

    map.flyTo({
      center: isSingle ? [markerData[0].lng, markerData[0].lat] : [33.480264, -13.039146],
      zoom: isSingle ? 14 : 8,
    });

    const handlePointClick = (e) => {
      const clickedData = e.features[0].properties.id;

      if (map.getLayer('points-shadow')) {
        map.setFilter('points-shadow', ['all', ['!', ['has', 'point_count']], ['==', ['get', 'id'], clickedData]]);
      }

      setSelectedMarker(clickedData)
    };

    const handlePointerEnter = () => { map.getCanvas().style.cursor = 'pointer'; };
    const handlePointerLeave = () => { map.getCanvas().style.cursor = ''; };
    const handleMapClick = (e) => {
      const features = map.queryRenderedFeatures(e.point, { layers: ['points'] });
      if (!features.length && map.getLayer('points-shadow')) {
        setSelectedMarker(null);
      }
    };

    const handleClusterClick = async (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters'],
      });
      const clusterId = features[0].properties.cluster_id;
      const zoom = await map.getSource('points').getClusterExpansionZoom(clusterId);
      map.easeTo({
        center: features[0].geometry.coordinates,
        zoom,
      });
    };

    map.on('click', 'points', handlePointClick);
    map.on('mouseenter', 'points', handlePointerEnter);
    map.on('mouseleave', 'points', handlePointerLeave);
    map.on('click', handleMapClick);
    map.on('click', 'clusters', handleClusterClick);

    return () => {
      if (map && !map._removed) {
        map.off('mouseenter', 'points', handlePointerEnter);
        map.off('mouseleave', 'points', handlePointerLeave);
        map.off('click', 'points', handlePointClick);
        map.off('click', handleMapClick);
      }
    };
  }, [map, isSingle, markerData, isMapLoaded, setSelectedMarker]);

  useEffect(() => {
    if (!map) return;

    if (!isMapLoaded) return;

    if (map.getLayer('points-shadow')) {
      map.setFilter('points-shadow', ['all', ['!', ['has', 'point_count']], ['==', ['get', 'id'], selectedMarker || -1]]);
    }
  }, [selectedMarker, map, isMapLoaded]);

  return null
}

export default MapMarkerLayer